import React, { memo, useEffect } from 'react';

import StepperCDS from '@sharedCR/coreDesignSystem/StepperCDS';
import { WithLoadingPropTypes } from 'hocs/withLoading';

import { usePrepareDisclosuresWizard } from '../../hooks';
import { WIZARD_STEPS, WizardStep } from '../../PrepareDisclosuresWizard.constants';
import { PrepareDisclosuresWizardTestIds } from '../../PrepareDisclosuresWizard.testIds';
import BorrowersDeliveryStep from '../steps/BorrowersDeliveryStep';
import FeesStep from '../steps/FeesStep';
import PreviewStep from '../steps/PreviewStep';
import ReadinessStep from '../steps/ReadinessStep';
import SendStep from '../steps/SendStep';
import WizardPostSendView from '../WizardPostSendView';

const STEP_COMPONENTS = {
  [WizardStep.READINESS]: ReadinessStep,
  [WizardStep.FEES]: FeesStep,
  [WizardStep.BORROWERS_DELIVERY]: BorrowersDeliveryStep,
  [WizardStep.PREVIEW]: PreviewStep,
  [WizardStep.SEND]: SendStep,
};

const PrepareDisclosuresWizardBody = ({ setIsLoading }) => {
  const { activeStep, isSent } = usePrepareDisclosuresWizard();

  useEffect(() => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
    }, 0);
  }, [setIsLoading]);

  const ActiveStepComponent = STEP_COMPONENTS[activeStep];

  return (
    <div
      className="p-48 flex flex-col gap-24 h-full overflow-y-auto"
      data-testid={PrepareDisclosuresWizardTestIds.BODY}
    >
      <StepperCDS activeStep={activeStep} steps={WIZARD_STEPS} />
      {isSent ? <WizardPostSendView /> : ActiveStepComponent && <ActiveStepComponent />}
    </div>
  );
};

PrepareDisclosuresWizardBody.propTypes = {
  ...WithLoadingPropTypes,
};

export default memo(PrepareDisclosuresWizardBody);
